module.exports = __webpack_public_path__ + "94b482ef6f9ca198f989791065091231.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/harvard_university_2023_chart.png
// module id = 1684
// module chunks = 0